/**
 * Copyright 2013-present, Novivia, Inc.
 * All rights reserved.
 */

import {__} from "language";
import AELoginForm from "@auex/react-components/LoginForm";
import BSButton from "react-bootstrap/Button";
import BSModal from "react-bootstrap/Modal";
import ContextWrapper from "./render/components/ContextWrapper";
import PropTypes from "prop-types";
import React, {Component} from "react";
import ReactDOM from "react-dom";

export function isUserLoggedIn() {
  return !!AuctionEx.userId;
}

class LoginModal extends Component {
  static propTypes = {
    csrfToken: PropTypes.string,
    message: PropTypes.string,
    onHide: PropTypes.func,
    visible: PropTypes.bool,
  };

  static defaultProps = {
    message: __("general::pleaseLogInToContinue"),
    onHide: () => {},
  };

  render() {
    return (
      <BSModal
        onHide={this.props.onHide}
        show={this.props.visible}
      >
        <BSModal.Header closeButton>
          <BSModal.Title>{this.props.message}</BSModal.Title>
        </BSModal.Header>
        <BSModal.Body>
          <AELoginForm
            csrfToken={this.props.csrfToken}
            socialLogin={this.props.features.privateTenant ? [] : undefined}
            registerLink
          />
        </BSModal.Body>
        <BSModal.Footer>
          <BSButton onClick={this.props.onHide}>
            {__("general::close")}
          </BSButton>
        </BSModal.Footer>
      </BSModal>
    );
  }
}

export let hideLoginModal;
function renderLoginModal(isVisible, message, csrfToken) {
  ReactDOM.render(
    <ContextWrapper __={__}>
      <LoginModal
        features={AuctionEx.features}
        message={message}
        onHide={hideLoginModal}
        visible={isVisible}
        csrfToken={csrfToken}
      />
    </ContextWrapper>,
    document.getElementById("login-modal"),
  );
}

export function showLoginModal(message, csrfToken) {
  renderLoginModal(true, message, csrfToken);
}

hideLoginModal = function() {
  renderLoginModal(false);
};

export function passThroughIfLoggedIn(message, csrfToken, callback) {
  if (!callback) {
    callback = csrfToken;
    csrfToken = message;
    message = undefined;
  }

  if (isUserLoggedIn()) {
    return callback(null, AuctionEx.userId);
  }

  showLoginModal(message, csrfToken);
}

export function bindIfLoggedIn(message, csrfToken, fn) {
  if (!fn) {
    fn = csrfToken;
    csrfToken = message;
    message = undefined;
  }

  if (message) {
    return function() {
      passThroughIfLoggedIn.call(
        null,
        message,
        csrfToken,
        () => fn.apply(null, arguments),
      );
    };
  }

  return function() {
    passThroughIfLoggedIn.call(null, csrfToken, () => fn.apply(null, arguments));
  };
}



// WEBPACK FOOTER //
// ../authentication.js